var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"loader-component"},[_c('b-spinner',{attrs:{"variant":"primary","label":"Spinning"}}),_c('span',{staticClass:"message"},[_vm._v(_vm._s(_vm.$t('loader.message')))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }